
import React from "react"
import { JARGON } from "../../modules/constants"
import SystemUpdateAltOutlinedIcon from "@mui/icons-material/SystemUpdateAltOutlined"

const tipEnabled = "export the table as a CSV file"
const iconButtons = {
  csv: {
    tipEnabled,
    tipDisabled: tipEnabled + JARGON.SUBSCRIBED_USERS_ONLY,
    icon: <SystemUpdateAltOutlinedIcon />,
    label: "Export as CSV",
  },
}

export default iconButtons